// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { productDetailsInfoStyles } from "@guestsupply/App/Widgets/ProductDetails/ProductDetailsInfo";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productDetailsInfoStyles.infoWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
    `,
};
productDetailsInfoStyles.infoSection = {
    css: css`
        &:empty {
            display: none;
        }
        min-width: 152px;
        ${xScreen("lte", "md")} {
            width: calc(50% - 8px);
            min-width: unset;
        }
    `,
};
productDetailsInfoStyles.labelValueStyles = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            weight: "bold",
            size: 14,
            css: css`
                line-height: 16px;
                &:after {
                    content: ":";
                }
            `,
        },
        text: {
            weight: 400,
            size: 14,
            css: css`
                line-height: 21px;
            `,
        },
    }),
};
